var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-component": "app-launcher-header" } }, [
    _c(
      "div",
      {
        staticClass: "title-block",
        on: {
          click: function ($event) {
            return _vm.$emit("go-back")
          },
        },
      },
      [
        _c("or-icon", { attrs: { icon: "arrow_back" } }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("HITL.app-launcher.title")) + "\n    "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    !!_vm.agent
      ? _c(
          "div",
          { staticClass: "buttons-block" },
          [
            !!_vm.actionsType
              ? _c("app-launcher-header-actions", {
                  attrs: {
                    "actions-type": _vm.actionsType,
                    label: _vm.saveButtonLabel,
                    "is-updating": _vm.isUpdating,
                  },
                  on: {
                    save: function ($event) {
                      return _vm.$emit("save")
                    },
                    update: function ($event) {
                      return _vm.$emit("update")
                    },
                    cancel: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !!_vm.actionsType
              ? _c("div", { staticClass: "divider" })
              : _vm._e(),
            _vm._v(" "),
            _c("app-launcher-header-agent-popup", {
              attrs: {
                avatar: _vm.avatar,
                agent: _vm.agent,
                "app-version": _vm.appVersion,
                options: _vm.options,
              },
              on: {
                "option-click": _vm.onOptionClick,
                "sign-out": function ($event) {
                  return _vm.$emit("sign-out")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }